import moment from 'moment';
import { sortTypes } from '../../../helpers/sortFns';
import { message } from 'antd';

export const defaultPeriod =  [moment().subtract(3, 'month'), moment()];
export const defaultStates = [1];

export const filterDelay = 1000;

export const messageAreaMaxCount = 800;
export const messageEditorMaxCount = 15000;
export const messageMinCount = 2;

export const initEditorLinkModalData = {
  visible: false,
  url: '',
  text: '',
  editMode: false,
};

export const questionOpenStateId = 1;
export const questionCloseStateId = 2;
export const questionsRequestToCloseStateId = 3;

export const answerStatuses = {
  needAnswer: { id: 'needAnswer', content: 'Требуется ответ' },
  notNeedAnswer: { id: 'notNeedAnswer', content: 'Не требуется ответ' },
};

export const reactions = {
  like: { id: 'like', content: 'С положительной оценкой' },
  dislike: { id: 'dislike', content: 'С отрицательной оценкой' },
};

export const questionsSortStates = {
  dateDesc: {
    value: 'dateDesc',
    content: 'Сначала новые',
    order: 'desc',
    orderBy: 'createTime',
    sortType: sortTypes.date,
  },
  dateAsc: {
    value: 'dateAsc',
    content: 'Сначала старые',
    order: 'asc',
    orderBy: 'createTime',
    sortType: sortTypes.date,
  },
  addressAsc: {
    value: 'addressAsc',
    content: 'По адресу, А-Я',
    order: 'asc',
    orderBy: 'fullAddress',
    sortType: sortTypes.string,
  },
  addressDesc: {
    value: 'addressDesc',
    content: 'По адресу, Я-А',
    order: 'desc',
    orderBy: 'fullAddress',
    sortType: sortTypes.string,
  },
};
